<template>
  <svg
    v-bind="$attrs"
    :width="width"
    :height="height"
    viewBox="0 0 9 3"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.5 0C3.88125 0 3.375 0.50625 3.375 1.125C3.375 1.74375 3.88125 2.25 4.5 2.25C5.11875 2.25 5.625 1.74375 5.625 1.125C5.625 0.50625 5.11875 0 4.5 0ZM7.875 0C7.25625 0 6.75 0.50625 6.75 1.125C6.75 1.74375 7.25625 2.25 7.875 2.25C8.49375 2.25 9 1.74375 9 1.125C9 0.50625 8.49375 0 7.875 0ZM1.125 0C0.50625 0 0 0.50625 0 1.125C0 1.74375 0.50625 2.25 1.125 2.25C1.74375 2.25 2.25 1.74375 2.25 1.125C2.25 0.50625 1.74375 0 1.125 0Z"
      :fill="fill"
    />
  </svg>
</template>

<script lang="ts" setup>
defineProps({
  width: {
    type: [String, Number],
    default: 9,
  },
  height: {
    type: [String, Number],
    default: 3,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
});
</script>